module.exports = __webpack_public_path__ + "img/engine_two.510f052a.png";